<template>
  <el-dialog
    :title="model.id > 0 ? '编辑分类' : '新建分类'"
    :visible.sync="visible"
    width="750px"
    @close="$emit('update:show', false)"
  >
    <!-- <el-dialog title="新增货品类别" :visible.sync="visible" @close="$emit('update:show', false)"> -->
    <el-form
      :model="model"
      :rules="rules"
      ref="form"
      size="small"
      label-width="100px"
    >
      <!-- <el-form-item label="上级分类" label-width="100px" v-show="model.father_id > 0">
        <el-select
          v-model="model.father_id"
          filterable
          placeholder="请选择"
          style="width: 100%"
          disabled
        >
          <el-option
            v-for="item in cates.filter(item => item.father_id == 0 && item.id != model.id)"
            :key="item.id"
            :label="item.name"
            :value="parseInt(item.id)"
          ></el-option>
        </el-select>
      </el-form-item>-->
      <el-form-item label="封面">
        <el-upload
          :action="uploadUrl"
          accept="image/*"
          :headers="uploadHeader"
          :show-file-list="false"
          :on-success="handleAvatarSuccess"
          :on-error="handleUploadError"
          :before-upload="beforeAvatarUpload"
        >
          <auth-img
            tag="el-image"
            style="width: 60px; height: 60px"
            :src="model.cover"
            fit="cover"
            v-if="model.cover"
          ></auth-img>
          <span v-else class="font-12">点击上传</span>
        </el-upload>
      </el-form-item>
      <el-form-item
        label="上级分类"
        label-width="100px"
        v-if="model.father_id > 0"
      >
        <el-input
          v-model="model.father_name"
          autocomplete="off"
          disabled
        ></el-input>
      </el-form-item>
      <el-form-item label="分类名称" label-width="100px" prop="name">
        <el-input v-model="model.name" autocomplete="off"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false" size="small">取 消</el-button>
      <el-button type="primary" @click="submitForm" size="small"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { createItemCategory, updateItemCategory } from '@/service/getData'
import { urlPerfix } from '@/config/env'
import store from '@/store/store'

export default {
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
    cates: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
  },
  data() {
    return {
      uploadUrl: urlPerfix + '/files/upload',
      uploadHeader: { Token: store.state.userInfo.token },
      visible: this.show,
      rules: {
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' },
          {
            min: 1,
            max: 30,
            message: '长度在 1 到 30 个字符',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  methods: {
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (this.model.id > 0) {
            let res = await updateItemCategory(this.model)
            if (res.code == 0) {
              this.$emit('updated', res.data)
            }
          } else {
            let res = await createItemCategory(this.model)
            if (res.code == 0) {
              this.$emit('created', res.data)
            }
          }
          this.visible = false
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleAvatarSuccess(res, file) {
      if (res.code == 0) {
        this.model.cover = res.data
      }
    },
    handleUploadError(err) {
      this.$message({
        message: '上传失败，请重试',
        type: 'error',
        center: true,
      })
    },
    beforeAvatarUpload(file) {
      const isJPG = true
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isJPG && isLt2M
    },
  },
}
</script>